import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { ScreenLoader } from '@/components/global/Loader';
import { useToast } from '@/hooks/use-toast';
import { supabaseClient } from '@/lib/supabase';
import { sendErrorToSentry } from '@/lib/utils';

import { ResetPasswordForm } from '../reset-password/-components/ResetPassword';

export const Route = createFileRoute('/(auth)/reset-password-on-invitation/')({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const { formatMessage } = useIntl();
  const { toast } = useToast();
  const [userEmail, setUserEmail] = useState<string>();

  useEffect(() => {
    (async () => {
      const refreshToken = new URLSearchParams(window.location.hash).get(
        'refresh_token',
      );

      if (refreshToken === null) {
        return;
      }

      const {
        data: { user },
        error,
      } = await supabaseClient.auth.refreshSession({
        refresh_token: refreshToken,
      });

      if (user === null) {
        toast({
          title: 'auth.resetPasswordOnInvitation.error',
          variant: 'destructive',
        });

        if (error !== null) {
          // We do not throw bc it would crash the app
          sendErrorToSentry(error);
        }

        return;
      }

      setUserEmail(user.email);
    })();
  }, [toast]);

  if (userEmail === undefined) {
    return <ScreenLoader />;
  }

  return (
    <ResetPasswordForm
      onPasswordReset={async password => {
        const { error } = await supabaseClient.auth.signInWithPassword({
          email: userEmail,
          password,
        });

        if (error !== null) {
          toast({
            title: 'auth.signIn.form.submit.error',
            variant: 'destructive',
          });

          throw error;
        }

        router.navigate({
          to: '/',
        });
      }}
      email={userEmail}
      title={formatMessage({
        id: 'auth.resetPasswordOnInvitation.title',
      })}
      subtitle={formatMessage({
        id: 'auth.resetPasswordOnInvitation.subtitle',
      })}
    />
  );
}
